import type { LensDatasetDryRunResponse } from '~/hooks/apis/reporting/useLeLensDatasetChecks';

import type { LensDataset } from '~/types/leLens';

export async function prepareDatasetSchemas(
  datasets: ReadonlyArray<LensDataset>,
  verify: (sql: string) => Promise<LensDatasetDryRunResponse>,
  previous: ReadonlyArray<LensDataset> = [],
): Promise<Array<LensDataset>> {
  return Promise.all(
    datasets.map(async (dataset) => {
      const unchanged = previous.some(
        (saved) => saved.id === dataset.id && saved.sql === dataset.sql && saved.columns?.length,
      );
      if (dataset.source?.kind === 'governed' || unchanged) {
        return dataset;
      }
      const checked = await verify(dataset.sql);
      const dateColumns = checked.columns.filter((column) => column.kind === 'date').map((column) => column.name);
      const availableDates = dataset.dateFilter?.available?.filter((column) => dateColumns.includes(column));
      const dateColumn =
        dataset.dateFilter && dateColumns.includes(dataset.dateFilter.column)
          ? dataset.dateFilter.column
          : availableDates?.length === 1
            ? availableDates[0]
            : dateColumns.length === 1
              ? dateColumns[0]
              : undefined;
      const { dateFilter, ...definition } = dataset;
      return {
        ...definition,
        columns: checked.columns,
        ...(dateFilter && dateColumn
          ? {
              dateFilter: { ...dateFilter, column: dateColumn, available: availableDates },
            }
          : {}),
        dryRun: {
          at: new Date().toISOString(),
          bytesProcessed: checked.bytesProcessed,
          referencedTables: checked.referencedTables,
        },
      };
    }),
  );
}
